import { configureStore } from "@reduxjs/toolkit";
import globalStateReducer from "./slice";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import assignmentAnalyticsReducer from "../reducers/assignmentAnalyticsReducer";
import adminRegistrationReducer from "../reducers/adminRegistrationReducer";
import adminLoginReducer from "../reducers/adminLoginReducer";
import superadminLoginReducer from "../reducers/superadminLoginReducer";
import addSchoolReducer from "../reducers/addSchoolReducer";
import getSchoolByIDReducer from "../reducers/getSchoolByIDReducer";
import getAllSchoolsReducer from "../reducers/getAllSchoolsReducer";
import getAllTeacherBySchoolReducer from "../reducers/getAllTeacherBySchoolReducer";
import getCourseListBySchoolIDReducer from "../reducers/getCourseListBySchoolIDReducer";
import profileLoginReducer from "../reducers/profileLoginReducer";
import addIndividualProfileReducer from "../reducers/addIndividualProfileReducer";
import userRegistrationReducer from "../reducers/userRegistrationReducer";
import addBulkProfileReducer from "../reducers/addBulkProfileReducer";
import firstLoginReducer from "../reducers/firstLoginReducer";
import getLetestTeacherReducer from "../reducers/getLetestTeacherReducer";
import getAllCoursesByTeacherIdReducer from "../reducers/getAllCoursesByTeacherIdReducer";
import getTeacherByTeacherIdReducer from "../reducers/getTeacherByTeacherIdReducer";
import getdataListReducer from "../reducers/getdataListReducer";
import getStudentByStudentIdReducer from "../reducers/getStudentByStudentIdReducer";
import getStudentEnrolledCoursesReducer from "../reducers/getStudentEnrolledCoursesReducer";
import historyReducer from "../reducers/historyReducer";
import getProfileDetailsReducer from "../reducers/getProfileDetailsReducer";
import * as Sentry from "@sentry/react";
import notificationListReducer from "../reducers/notificationListReducer";
import sentInvitationListReducer from "../reducers/sentInvitationListReducer";
import updateTeacherProfileReducer from "../reducers/updateTeacherProfileReducer";
import getAssignmentStatsReducer from "../reducers/getAssignmentStatsReducer";
import getLessonStatsReducer from "../reducers/getLessonStatsReducer";
import getAllCoursesReducer from "../reducers/getAllCoursesReducer";
import adminDashboardCountReducer from "../reducers/adminDashboardCountReducer";
import getSchoolDetailsReducer from "../reducers/getSchoolDetailsReducer";
import updateSchoolReducer from "../reducers/updateSchoolReducer";
import adminDashboardGraphReducer from "../reducers/adminDashboardGraphReducer";
import deleteCourseReducer from "../reducers/deleteCourseReducer";
import AddSchoolAdminReducer from "../reducers/addSchoolAdminReducer";
import getFileIdByNameReducer from "../reducers/getFileIdByNameReducer";
import getUploadFileStatusReducer from "../reducers/getUploadFileStatusReducer";
import deleteLessonReducer from "../reducers/deleteLessonReducer";
import deleteAssignmentReducer from "../reducers/deleteAssignmentReducer";
import removeStudentsFromCourseReducer from "../reducers/removeStudentsFromCourseReducer";
import getTextToSpeechReducer from "../reducers/getTextToSpeechReducer";
import courseImageGenerateReducer from "../reducers/courseImageGenerateReducer";
import getAssignmentsByLessonReducer from "../reducers/getAssignmentsByLessonReducer";
import couseFileUploadReducer from "../reducers/couseFileUploadReducer";
import courseFileUploadStatusReducer from "../reducers/courseFileUploadStatusReducer";
import getCourseFileUploadsReducer from "../reducers/getCourseFileUploadsReducer";
import deleteUploadedCourseFileReducer from "../reducers/deleteUploadedCourseFileReducer";
import publishtoSchoologyReducer from "../reducers/publishtoSchoologyReducer";
import syncSchoologyReducer from "../reducers/setSyncSchoologyReducer";
import submitGoogleTokenReducer from "../reducers/submitGoogleTokenReducer";
import getGoogleTokenReducer from "../reducers/getGoogleTokenReducer";
import googleDriveSyncReducer from "../reducers/googleDriveSyncReducer";
import googleDriveCourseSyncReducer from "../reducers/googleDriveCourseSyncReducer";
import unlinkGoogleDriveReducer from "../reducers/unlinkGoogleDriveReducer";
import linkGoogleDriveReducer from "../reducers/linkGoogleDriveReducer";
import createEmbeddingsReducer, {
  setCreateEmbeddings,
} from "../reducers/createEmbeddingsReducer";
import createCourseEmbeddingsReducer from "../reducers/createCourseEmbeddingsReducer";
import getPracticeAssignmentsReducer from "../reducers/getPracticeAssignmentsReducer";
import generatePracticeAssignmentReducer from "../reducers/generatePracticeAssignmentReducer";
import setCourseCheckPublishtoSchoology from "../reducers/courseCheckPublishtoSchoologyReducer";
import getSchoologyCourseReducer from "../reducers/getAllSchoologyCoursesReducer";
import syncWithSrdsReducer from "../reducers/syncWithSrdsReducer";
import syncWithSrdsDatabaseReducer from "../reducers/syncWithSrdsDatabaseReducer";
import schoologyRecentSyncReducer from "../reducers/schoologyRecentSyncReducer";
import importSchoologyCourseReducer from "../reducers/importSchoologyCourseReducer";
import schoologyDetailLogsReducer from "../reducers/schoologyDetailLogsReducer";
import syncAssignmentsSchoologyReducer from "../reducers/syncAssignmentsSchoologyReducer";
import reFormatterReducer from "../reducers/reFormatterReducer";
import getCompetativeExamScoreReducer from "../reducers/getCompetativeExamScoreReducer";
import getallCourseListByTeacherIdReducer from "../reducers/getAllCourseListByTeacherReducer";
import getenrolledStudentListReducer from "../reducers/getEnrolledStudentListReducer";
import getOverallPerformanceScoreByTeacherReducer from "../reducers/getOverallPerformanceScoreByTeacherReducer";
import getEventOverviewByTeacherReducer from "../reducers/getEventOverviewByTeacherReducer";
import getAifeedbackPointByTeacherReducer from "../reducers/getAiFeedbackPointByTeacherReducer";
import getAllCourseListByStudentReducer from "../reducers/getAllCourseListByStudentReducer";
//import { getEnrolledStudentList } from "../actions/getEnrolledStudentListAction";
import getEditGradingReducer from "../reducers/editGradingReducer";
import createLessonsReducer from "../reducers/createLessonsReducer";
import selectedCourseDataReducer from "../reducers/selectedCourseDataReducer";
import chatDrawerStateReducer from "../reducers/chatDrawerReducers";
import getAccessControlRoleReducer from "../reducers/getAccessControlRoleReducer";
import getTeacherAndEnrolledListReducer from "../reducers/getTeacherAndEnrolledListReducer";
import departmentsReducer from "../reducers/departmentReducer";
import getDepartmentDataReducer from "../reducers/getDepartmentDataReducer";
import courseReducer from "../reducers/getEnrolledCoursesDataReducer";
import addTeacherReducer from "../reducers/addTeacherReducer";
import getCourseTeachersReducer from "../reducers/getCourseTeachersReducer";
import getActivityLogsReducer from "../reducers/getActivityLogsReducer";
import cartSuggestedCoursesReducer from "../reducers/cartSuggestedCoursesReducer";
import removeCartReducer from "../reducers/removeCartReducer";
import cartlistReducer from "../reducers/cartlistReducer";
import addToCartReducer from "../reducers/addToCartReducer";
import getPlatformFeeReducer from "../reducers/getPlatformFeeReducer";
import coursePaymentReducer from "../reducers/coursePaymentReducer";
import getAllArchivedCoursesReducer from "../reducers/getAllArchivedCoursesReducer";
import getFreeDomainReducer from "../reducers/getFreeDomainReducer";

const globalStatePersistConfig = {
  key: "globalState",
  storage,
  whitelist: [
    "token",
    "role",
    "email",
    "teacher_details",
    "student_details",
    "has_profile",
    "datalist",
    "school_id",
    "grade_details",
    "school_details",
    "subadmin_details",
    "currency_symbol",
    "enabled_modules",
  ],
};

const persistedReducer = persistReducer(
  globalStatePersistConfig,
  globalStateReducer,
);
// RTK v2: getDefaultMiddleware is no longer exported; use the middleware callback
const middlewareOptions = {
  serializableCheck: {
    ignoredActions: ["persist/PERSIST"],
    ignoredActionPaths: ["meta.arg", "payload.timestamp"],
    ignoredPaths: ["items.dates"],
  },
};

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  // Optionally pass options listed below
});

const store = configureStore({
  reducer: {
    globalState: persistedReducer,
    profilelogin: profileLoginReducer,
    userregistration: userRegistrationReducer,
    firstlogin: firstLoginReducer,
    adminregistration: adminRegistrationReducer,
    adminlogin: adminLoginReducer,
    superadminLogin: superadminLoginReducer,
    addSchool: addSchoolReducer,
    schoolById: getSchoolByIDReducer,
    schoolList: getAllSchoolsReducer,
    fetchSchoolData: getAllTeacherBySchoolReducer,
    getCoursesbySchoolId: getCourseListBySchoolIDReducer,
    addIndividualProfile: addIndividualProfileReducer,
    addbulkProfile: addBulkProfileReducer,
    letestteacherlist: getLetestTeacherReducer,
    getallCoursesByTeacherId: getAllCoursesByTeacherIdReducer,
    getteacherbyTeacherId: getTeacherByTeacherIdReducer,
    getdatalist: getdataListReducer,
    getstudentByStudentId: getStudentByStudentIdReducer,
    getStudentEnrolledCourses: getStudentEnrolledCoursesReducer,
    assgnAnalytics: assignmentAnalyticsReducer,
    navigateHistory: historyReducer,
    profileDetails: getProfileDetailsReducer,
    notificationList: notificationListReducer,
    sentInvitations: sentInvitationListReducer,
    updateTeacherProfile: updateTeacherProfileReducer,
    assignmentStats: getAssignmentStatsReducer,
    lessonStats: getLessonStatsReducer,
    allcoursesList: getAllCoursesReducer,
    superadminCount: adminDashboardCountReducer,
    schoolDetails: getSchoolDetailsReducer,
    updateSchoolDetails: updateSchoolReducer,
    adminDashboardGraph: adminDashboardGraphReducer,
    deleteCourseById: deleteCourseReducer,
    addSchoolAdmin: AddSchoolAdminReducer,
    getFileIdByName: getFileIdByNameReducer,
    getFileUploadStatus: getUploadFileStatusReducer,
    deleteLesson: deleteLessonReducer,
    deleteAssignment: deleteAssignmentReducer,
    removestudentfromcourse: removeStudentsFromCourseReducer,
    texttospeech: getTextToSpeechReducer,
    getcourseImage: courseImageGenerateReducer,
    getassignmentsbyLesson: getAssignmentsByLessonReducer,
    coursefileUploads: couseFileUploadReducer,
    courseFileUploadStatus: courseFileUploadStatusReducer,
    getCourseFileUploads: getCourseFileUploadsReducer,
    deleteUploadedCourseFile: deleteUploadedCourseFileReducer,
    publishtoSchoology: publishtoSchoologyReducer,
    syncSchoology: syncSchoologyReducer,
    submitGoogleToken: submitGoogleTokenReducer,
    getGoogleAccessToken: getGoogleTokenReducer,
    googleDriveSync: googleDriveSyncReducer,
    googleDriveCourseSync: googleDriveCourseSyncReducer,
    unlinkgdrive: unlinkGoogleDriveReducer,
    linkgdrive: linkGoogleDriveReducer,
    createEmbeddings: createEmbeddingsReducer,
    createCourseEmbeddings: createCourseEmbeddingsReducer,
    getPracticeAssignments: getPracticeAssignmentsReducer,
    generatePracticeAssignment: generatePracticeAssignmentReducer,
    courseCheckPublishtoSchoology: setCourseCheckPublishtoSchoology,
    getSchoologyCourse: getSchoologyCourseReducer,
    syncWithSrds: syncWithSrdsReducer,
    syncDatabaseCoursesWithSrds: syncWithSrdsDatabaseReducer,
    getSchoologyRecentSync: schoologyRecentSyncReducer,
    importSchoologyCourse: importSchoologyCourseReducer,
    schoologyDetailLogs: schoologyDetailLogsReducer,
    syncAssignmentsWithSchoology: syncAssignmentsSchoologyReducer,
    reFormatter: reFormatterReducer,
    getCompetativeExamScore: getCompetativeExamScoreReducer,
    getAllCourseListByTeacher: getallCourseListByTeacherIdReducer, //reducer for dashboard course list by teacher id
    getEnrolledStudentList: getenrolledStudentListReducer, //reducer for dashboard student list by teacher id
    getOverallPerformanceScoreByTeacher: getOverallPerformanceScoreByTeacherReducer, //reduer for dashboard Overall performance
    getEventOverviewByTeacher: getEventOverviewByTeacherReducer, //reducer for dashboard event overview
    getAifeedbackPointByTeacher: getAifeedbackPointByTeacherReducer,
    editGrading: getEditGradingReducer,
    getAllCourseListByStudent: getAllCourseListByStudentReducer,
    createLessons: createLessonsReducer,
    selectedCourseData: selectedCourseDataReducer,
    ChatDrawerState: chatDrawerStateReducer,
    getAccessControlRoleList: getAccessControlRoleReducer,
    getTeacherAndEnrolled: getTeacherAndEnrolledListReducer,
    departmentData: departmentsReducer,
    getDepartmentData: getDepartmentDataReducer,
    EnrolledCourseData:courseReducer,
    addTeacher: addTeacherReducer,
    getCourseTeachers: getCourseTeachersReducer,
    getActivityLogs: getActivityLogsReducer,
    platformFee: getPlatformFeeReducer,
    suggestedCourses: cartSuggestedCoursesReducer,
    removeCartData: removeCartReducer,
    addToCart: addToCartReducer,
    cartlist: cartlistReducer,
    proceedToPay: coursePaymentReducer,
    archiveCourseList : getAllArchivedCoursesReducer,
    getfreeDomain: getFreeDomainReducer
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(middlewareOptions),
  enhancers: (getDefaultEnhancers) =>
    getDefaultEnhancers().concat(sentryReduxEnhancer),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const persistor = persistStore(store);
export default store;
